// Alerta físico para avisos de vez (you're next / you're on): vibração em
// Android e um bipe suave via WebAudio. Falha silenciosamente quando não é
// suportado (iOS sem gesto prévio, permissões de som, etc.) — o toast visual
// é o fallback garantido.
let audioCtx: AudioContext | null = null;

export function alertTurn(): void {
  try {
    navigator.vibrate?.([120, 60, 120]);
  } catch {
    // vibração não suportada — ignora
  }

  try {
    const Ctor =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    audioCtx = audioCtx || new Ctor();
    void audioCtx.resume();
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = 'sine';
    osc.frequency.value = 880;
    const now = audioCtx.currentTime;
    gain.gain.setValueAtTime(0.001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(now);
    osc.stop(now + 0.55);
  } catch {
    // som bloqueado pelo browser — o toast visual chega na mesma
  }
}
